var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{staticClass:"report",attrs:{"title":_vm.$t('reportView.report'),"icon":"bullhorn"}},[_c('ProblemReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }